module.exports = __webpack_public_path__ + "static/img/cont44_01.6495e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_01.jpg
// module id = jE27
// module chunks = 0